import { Box, Text, VStack } from '@chakra-ui/react';
import { FC } from 'react';
import { Outlet, useLocation } from 'react-router';
import MarketComingSoonImage from '~/apps/consumer/images/signup/market-coming-soon.svg';
import { SVGComponent } from '~/common/components/SVGComponent';
import { MainLayout } from '../../pages/MainLayout';

export const NotSupportedMarket: FC = () => {
  return (
    <VStack
      alignItems="center"
      flexGrow={1}
      height="100dvh"
      justifyContent="center"
    >
      <VStack spacing={1}>
        <Text color="white" fontSize="32px" textAlign="center">
          We’re coming soon to your market
        </Text>
        <Text
          color="whiteAlpha.500"
          fontSize="18px"
          textAlign="center"
          whiteSpace="pre"
        >
          You’ll be the first to know when we launch!
        </Text>
      </VStack>

      <VStack mt={{ base: '0px', md: '-130px' }} position="relative" zIndex={0}>
        <SVGComponent url={MarketComingSoonImage} width="100%" />
      </VStack>
    </VStack>
  );
};

export const NotSupportedMarketWithMainLayout: FC = () => {
  const { pathname } = useLocation();

  return (
    <MainLayout>
      <Box height="100%" px={4} width="100%">
        {pathname.includes('account') ? <Outlet /> : <NotSupportedMarket />}
      </Box>
    </MainLayout>
  );
};
